import { ViewComponentModel, IndicatorManager } from 'app/views/accessories/IndicatorManager';

export class EmptyIndicatorManager implements IndicatorManager {
    /**
     * Simplest implementation of an indicator manager which never produces any indicators
     */
    constructor() {}

    getCurrentIndicators(assetId: number): Array<ViewComponentModel> {
        return [];
    }

    onChange(fn: () => void): () => void {
        return function () {};
    }

    destroy(): void {}
}
